module.exports = __webpack_public_path__ + "media/images/arrow-fc14dd90.svg";